<div>
    <div class="wizard-header row">
        <div class="col-12 page-title">
            {{'specialOffers.title' | translate}}
        </div>
    </div>

    <div class="wizard-container">
        <button
            class="btn link-btn btn-back-txt"
            (click)="redirectToSpecialOffersList()">
            <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
            <span>
                {{("specialOffers.wizard.navSpecialOffersList" | translate)}}
            </span>
        </button>

        <div class="wizard-main-content">
            <form #form="ngForm">
                <ng-container>
                    <div class="row">
                        <div class="col-12 wizard-question">
                            {{ "specialOffers.wizard.campaignDetails.title" | translate }}
                        </div>
                        <div class="row justify-content-center mb-3">
                            <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3">
                                <label class="label-input required">
                                    {{'specialOffers.wizard.campaignDetails.startDate' | translate}}
                                </label>
                                <div class="date-input-container">
                                    <kendo-datepicker
                                        HJSuppress
                                        [(ngModel)]="specialOffer.startDate"
                                        name="startDate"
                                        class="custom-kendo-control-xl"
                                        [fillMode]="fillModeOutline"
                                        [rounded]="roundedLarge"
                                        #startDateInput
                                        (click)="!startDateInput.isOpen ? startDateInput.toggle() : null"
                                        [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                        [disabledDates]="disabledPastDates"
                                        [disabled]="(specialOffer.status === specialOfferStatus.UPCOMING) && !specialOffer.allowEdit">
                                        <kendo-datepicker-messages
                                            today="{{ 'calendar.today' | translate }}"
                                            toggle="{{ 'calendar.toggle' | translate }}">
                                        </kendo-datepicker-messages>
                                    </kendo-datepicker>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3">
                                <label class="label-input required">
                                    {{'specialOffers.wizard.campaignDetails.endDate' | translate}}
                                </label>
                                <div class="date-input-container">
                                    <kendo-datepicker
                                        HJSuppress
                                        [(ngModel)]="specialOffer.endDate"
                                        name="endDate"
                                        class="custom-kendo-control-xl"
                                        [fillMode]="fillModeOutline"
                                        [rounded]="roundedLarge"
                                        #endDateInput
                                        (click)="!endDateInput.isOpen ? endDateInput.toggle() : null"
                                        [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                        [disabledDates]="disabledDatesBeforeStartDate">
                                        <kendo-datepicker-messages
                                            today="{{ 'calendar.today' | translate }}"
                                            toggle="{{ 'calendar.toggle' | translate }}">
                                        </kendo-datepicker-messages>
                                    </kendo-datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input required">
                                    {{ "specialOffers.wizard.campaignDetails.type" | translate }}
                                </label>
                                <div class="input-dropdown-container">
                                    <kendo-combobox
                                        HJSuppress
                                        class="custom-kendo-control-xl"
                                        [size]="sizeLarge"
                                        [fillMode]="fillModeOutline"
                                        [rounded]="roundedLarge"
                                        name="campaignTypeId"
                                        [placeholder]="'specialOffers.wizard.campaignDetails.placeholder.selectType' | translate"
                                        [clearButton]="false"
                                        [valuePrimitive]="true"
                                        [data]="campaignTypes"
                                        [valueField]="'id'"
                                        [textField]="'value'"
                                        [(ngModel)]="specialOffer.dictionaryCampaignTypeId"
                                        [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                        #campaignType
                                        (click)="!campaignType.isOpen && !campaignType.disabled ?
                                        campaignType.toggle() : null"
                                        (ngModelChange)="campaignTypeSelectedHandler($event)">
                                    </kendo-combobox>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input required">
                                    {{ "specialOffers.wizard.campaignDetails.partner" | translate }}
                                </label>
                                <div class="input-dropdown-container">
                                    <kendo-combobox
                                        HJSuppress
                                        class="custom-kendo-control-xl"
                                        [size]="sizeLarge"
                                        [fillMode]="fillModeOutline"
                                        [rounded]="roundedLarge"
                                        name="dealerId"
                                        [placeholder]="
                                        'specialOffers.wizard.campaignDetails.placeholder.selectPartner' | translate"
                                        [clearButton]="false"
                                        [valuePrimitive]="true"
                                        [data]="dealers"
                                        [valueField]="'partnerCompanyId'"
                                        [textField]="'name'"
                                        [(ngModel)]="specialOffer.dealerExternalEntityId"
                                        [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                        #dealer
                                        (click)="!dealer.isOpen && !dealer.disabled ?
                                        dealer.toggle() : null"
                                        [disabled]="(specialOffer.status === specialOfferStatus.UPCOMING) && !specialOffer.allowEdit"
                                        (ngModelChange)="dealerSelectHandler($event)">
                                    </kendo-combobox>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input required">
                                    {{ "specialOffers.wizard.campaignDetails.assetManufacturer" | translate }}
                                </label>
                                <div class="input-dropdown-container">
                                    <kendo-combobox
                                        HJSuppress
                                        class="custom-kendo-control-xl"
                                        [size]="sizeLarge"
                                        [fillMode]="fillModeOutline"
                                        [rounded]="roundedLarge"
                                        name="manufacturerId"
                                        [placeholder]="'specialOffers.wizard.campaignDetails.placeholder.selectAssetManufacturer' | translate"
                                        [clearButton]="false"
                                        [valuePrimitive]="true"
                                        [data]="manufacturers"
                                        [valueField]="'partnerCompanyId'"
                                        [textField]="'name'"
                                        [(ngModel)]="specialOffer.manufacturerExternalEntityId"
                                        [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                        #manufacturer
                                        (click)="!manufacturer.isOpen && !manufacturer.disabled ?
                                        manufacturer.toggle() : null"
                                        [disabled]="(specialOffer.status === specialOfferStatus.UPCOMING) && !specialOffer.allowEdit"
                                        (ngModelChange)="manufacturerSelectHandler($event)">
                                    </kendo-combobox>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-8 col-lg-6 col-xxl-5 col-xxxl-4">
                                <label class="label-input required">
                                    {{'specialOffers.wizard.campaignDetails.assetPrice' | translate}}
                                </label>
                                <div>
                                    <kendo-numerictextbox
                                        HJSuppress
                                        class="l-numeric-textbox-container"
                                        [spinners]="false"
                                        [min]="0"
                                        [(ngModel)]="specialOffer.assetPrice"
                                        placeholder="{{'specialOffers.wizard.campaignDetails.placeholder.typeAssetPrice' | translate}}"
                                        name="assetPrice"
                                        [disabled]="(specialOffer.status === specialOfferStatus.UPCOMING) && !specialOffer.allowEdit">
                                    </kendo-numerictextbox>
                                </div>
                                <span class="l-currency-symbol"></span>
                            </div>
                            <div class="col-md-4 col-lg-4 col-xxl-3 col-xxxl-2">
                                <label class=" label-input required">
                                    {{ "specialOffers.wizard.campaignDetails.currency" | translate }}
                                </label>
                                <div class="input-dropdown-container">
                                    <kendo-combobox
                                        HJSuppress
                                        class="custom-kendo-control-xl"
                                        [size]="sizeLarge"
                                        [fillMode]="fillModeOutline"
                                        [rounded]="roundedLarge"
                                        name="currencyId"
                                        [placeholder]="'specialOffers.wizard.campaignDetails.placeholder.selectCurrency' | translate"
                                        [clearButton]="false"
                                        [textField]="'name'"
                                        [valueField]="'assetId'"
                                        [valuePrimitive]="true"
                                        [data]="currencies"
                                        [valueField]="'id'"
                                        [textField]="'code'"
                                        [(ngModel)]="specialOffer.dictionaryCurrencyExternalEntityId"
                                        [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                        #currency
                                        (click)="!currency.isOpen && !currency.disabled ?
                                        currency.toggle() : null"
                                        (ngModelChange)="currencySelectHandler($event)">
                                    </kendo-combobox>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex mb-3">
                                <input
                                    HJSuppress
                                    class="d-flex me-3"
                                    type="checkbox"
                                    kendoCheckBox
                                    size="large"
                                    rounded="large"
                                    [(ngModel)]="specialOffer.assetPriceWithVat"
                                    name="priceWithVat"
                                    id="priceWithVat"/>
                                <label for="priceWithVat" class="cursor-pointer">
                                    {{ "specialOffers.wizard.campaignDetails.priceWithVat" | translate }}
                                </label>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div
                                HJSuppress
                                class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex"
                                [innerHTML]="'common.requiredFields' | translate">
                            </div>
                        </div>
                        <div class="col-12 action">
                            <div class="d-flex justify-content-center mt-5">
                                <button
                                    class="btn primary-btn"
                                    [disabled]="(!specialOffer.startDate || !specialOffer.endDate || !specialOffer.dictionaryCampaignTypeId || !specialOffer.dealerExternalEntityId || !specialOffer.manufacturerExternalEntityId || !specialOffer.assetPrice || !specialOffer.dictionaryCurrencyExternalEntityId)"
                                    (click)="nextStepHandler()">
                                    {{ "specialOffers.wizard.nextBtn" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </form>
        </div>
    </div>
</div>